export default [
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_comoSeContrato',
    salida: '<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{contrato_comoSeContrato}</span> = LP',
    descripcion: 'Describe como fue contratado',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_numero',
    salida: '<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{contrato_numero} </span> = LS-CIDUE-MD-OP-0000-00',
    descripcion: 'Código de identificación único del contrato',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_fecha',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">{contrato_fecha}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fecha_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fecha_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Fecha del contrato',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_objeto',
    salida: '<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{contrato_objeto} </span> = "Pavimentación de calle..."',
    descripcion: 'Descripción del objeto del contrato',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_importeCostoDirecto',
    salida: `<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{contrato_importeCostoDirecto}</span> = 100,000.00
              <br><span style="color:blue;font-weight:bold;">{contrato_importeCostoDirecto_texto} </span> = CIEN MIL PESOS 00/100 CENTAVOS M.N.`,
    descripcion: 'Importe de costos directos del contrato',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_porcentajeCostoIndirectos',
    salida: '<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{contrato_porcentajeCostoIndirectos}</span> = 13.7',
    descripcion: 'Porcentaje de los costos indirectos del contrato',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_importeCostoIndirectos',
    salida: `<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{contrato_importeCostoIndirectos}</span> = 100,000.00
              <br><span style="color:blue;font-weight:bold;">{contrato_importeCostoIndirectos_texto} </span> = CIEN MIL PESOS 00/100 CENTAVOS M.N.`,
    descripcion: 'Importe de costos indirectos del contrato',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_porcentajeUtilidad',
    salida: '<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{contrato_porcentajeUtilidad}</span> = 8.5',
    descripcion: 'Porcentaje de utilidad del contrato',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_importeUtilidad',
    salida: `<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{contrato_importeUtilidad}</span> = 100,000.00
              <br><span style="color:blue;font-weight:bold;">{contrato_importeUtilidad_texto} </span> = CIEN MIL PESOS 00/100 CENTAVOS M.N.`,
    descripcion: 'Importe de utilidad del contrato',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_porcentajeCargosAdicionales',
    salida: '<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{contrato_porcentajeCargosAdicionales}</span> = 0.3',
    descripcion: 'Porcentaje de cargos adicionales del contrato',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_importeCargosAdicionales',
    salida: `<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{contrato_importeCargosAdicionales}</span> = 100,000.00
              <br><span style="color:blue;font-weight:bold;">{contrato_importeCargosAdicionales_texto} </span> = CIEN MIL PESOS 00/100 CENTAVOS M.N.`,
    descripcion: 'Importe de cargos adicionales del contrato',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_porcentajeCostoFinanciero',
    salida: '<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{contrato_porcentajeCostoFinanciero}</span> = 0.3',
    descripcion: 'Porcentaje de costos financieros del contrato',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_importeCostoFinanciero',
    salida: `<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{contrato_importeCostoFinanciero}</span> = 100,000.00
              <br><span style="color:blue;font-weight:bold;">{contrato_importeCostoFinanciero_texto} </span> = CIEN MIL PESOS 00/100 CENTAVOS M.N.`,
    descripcion: 'Importe de costos financieros del contrato',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_importe',
    salida: `<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{contrato_importe}</span> = 100,000.00
              <br><span style="color:blue;font-weight:bold;">{contrato_importe_texto} </span> = CIEN MIL PESOS 00/100 CENTAVOS M.N.`,
    descripcion: 'Importe del contrato',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_iva',
    salida: `<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{contrato_iva}</span> = 100,000.00
              <br><span style="color:blue;font-weight:bold;">{contrato_iva_texto} </span> = CIEN MIL PESOS 00/100 CENTAVOS M.N.`,
    descripcion: 'Importe de iva del contrato',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_total',
    salida: `<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{contrato_total}</span> = 100,000.00
              <br><span style="color:blue;font-weight:bold;">{contrato_total_texto} </span> = CIEN MIL PESOS 00/100 CENTAVOS M.N.`,
    descripcion: 'Importe total del contrato',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_fechaInicio',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">{contrato_fechaInicio}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaInicio_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaInicio_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Fecha de inicio del contrato',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_fechaTermino',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">{contrato_fechaTermino}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaTermino_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaTermino_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Fecha de termino del contrato',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'modificado.fechaInicio',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">{modificado.fechaInicio}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{modificado.fechaInicio_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{modificado.fechaInicio_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Fecha de inicio modificada',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'modificado.fechaTermino',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">{modificado.fechaTermino}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{modificado.fechaTermino_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{modificado.fechaTermino_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Fecha de termino modificada',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'obras',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">
        {FOR obra IN obras}<br>{INS $obra.ejercicio} - {INS $obra.clave} - {INS $obra.meta}
        <br>{END-FOR obra}</span> = <br>2021 - CVE-001 - OBRA 001<br>2022 - CVE-002 - OBRA 002<br>2023 - CVE-003 - OBRA 003`,
    descripcion: 'Lista de obras del contrato',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_plazo',
    salida: '<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{contrato_plazo} </span> = 360',
    descripcion: 'Plazo en días del contrato',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_residente',
    salida: '<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{contrato_residente} </span> = PEDRO ROBLES...',
    descripcion: 'Residente del contrato',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_supervisionExterna',
    salida: `<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{contrato_supervisionExternaRazonSocial} </span> = CONSTRUCCIONES X...
    <br><span style="color:blue;font-weight:bold;">{contrato_supervisionExternaRepresentante} </span> = JUAN ROBLES...`,
    descripcion: 'Datos de la supervisión externa del contrato',
    visible: true,
  },
  // Contratista
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contratista',
    salida: `<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{contratista.nombreRazonSocial} </span> = "RAZÓN SOCIAL..."
    <br><span style="color:blue;font-weight:bold;">{contratista.nombreRepresentante} </span> = "JUAN FLORES..."
    <br><span style="color:blue;font-weight:bold;">{contratista.rfc} </span> = "AAAA99..."
    <br><span style="color:blue;font-weight:bold;">{contratista.municipio} </span> = "HERMOSILLO"
    <br><span style="color:blue;font-weight:bold;">{contratista.entidad} </span> = "SONORA"
    <br><span style="color:blue;font-weight:bold;">{contratista.calle} </span> = "CALLE PRINCIPAL..."
    <br><span style="color:blue;font-weight:bold;">{contratista.colonia} </span> = "CENTRO..."
    <br><span style="color:blue;font-weight:bold;">{contratista.codigoPostal_valor} </span> = "83000"
    <br><span style="color:blue;font-weight:bold;">{contratista.nacionalidad} </span> = "MEXICANA..."
    <br><span style="color:blue;font-weight:bold;">{contratista.correoElectronico} </span> = "CORREO@DOMINIO..."
    

    `,
    descripcion: 'Datos del contratista',
    visible: true,
  },
  // Supervisores
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'superintendentes',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">
        {FOR superintendente IN superintendentes}<br>{INS $superintendente.nombreCompleto}
        <br>{END-FOR superintendente}</span> = <br>JUAN FLORES<br>PEDRO TORRES
        <br><br>Primer Superintendente:<br><span style="color:blue;font-weight:bold;">
        {superintendentes[0].nombreCompleto}</span> = JUAN FLORES`,
    descripcion: 'Lista de superintendentes del contrato',
    visible: true,
  },
  // Anticipos
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'anticipos',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">
        {FOR anticipo IN anticipos}<br>{INS $anticipo.fecha} - {INS $anticipo.total}
        <br>{END-FOR anticipo}</span> = <br>01/02/2022 - 116,000.00<br>20/02/2022 - 116,000.00
        <br><br>Primer Anticipo:<br><span style="color:blue;font-weight:bold;">
        {anticipos[0].fecha}</span> = 01/02/2022
        <br><span style="color:blue;font-weight:bold;">
        {anticipos[0].importe}</span> = 100,000.00
        <br><span style="color:blue;font-weight:bold;">
        {anticipos[0].iva}</span> = 16,000.00
        <br><span style="color:blue;font-weight:bold;">
        {anticipos[0].total}</span> = 116,000.00
        <br><span style="color:blue;font-weight:bold;">
        {anticipos[0].porcentaje}</span> = 15.0
        <br><br>Para importe en texto utilice
        <br><span style="color:blue;font-weight:bold;">
        {anticipos[0].importe_texto}</span> = CIEN MIL PESOS 00/100 CENTAVOS M.N.
        <br><br>Para el resto de importes agregue _texto al nombre<br>del dato para obtener el importe en texto.
        <br><br>Para fecha en texto utilice
        <br><span style="color:blue;font-weight:bold;">
        {anticipos[0].fecha_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Lista de anticipos del contrato',
    visible: true,
  },
  // Convenios
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'convenios',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">
        {FOR convenio IN convenios}<br>{INS $convenio.numero} - {INS $convenio.fecha} - {INS $convenio.total}
        <br>{END-FOR convenio}</span> = <br>CONV-001 - 01/02/2022 - 116,000.00<br>CONV-002 - 01/04/2022 - 232,000.00
        <br><br>Primer Convenio:
        <br><span style="color:blue;font-weight:bold;">
        {convenios[0].tipo}</span> = 
        <br><span style="color:blue;font-weight:bold;">
        {convenios[0].numero}</span> = CONV-001
        <br><span style="color:blue;font-weight:bold;">
        {convenios[0].fecha}</span> = 01/02/2022
        <br><span style="color:blue;font-weight:bold;">
        {convenios[0].importe}</span> = 100,000.00
        <br><span style="color:blue;font-weight:bold;">
        {convenios[0].iva}</span> = 16,000.00
        <br><span style="color:blue;font-weight:bold;">
        {convenios[0].total}</span> = 116,000.00
        <br><span style="color:blue;font-weight:bold;">
        {convenios[0].fechaInicio}</span> = 01/02/2022
        <br><span style="color:blue;font-weight:bold;">
        {convenios[0].fechaTermino}</span> = 01/10/2022
        <br><br>Para importe en texto utilice
        <br><span style="color:blue;font-weight:bold;">
        {convenios[0].importe_texto}</span> = CIEN MIL PESOS 00/100 CENTAVOS M.N.
        <br><br>Para el resto de importes agregue _texto al nombre<br>del dato para obtener el importe en texto.
        <br><br>Para fecha en texto utilice
        <br><span style="color:blue;font-weight:bold;">
        {convenios[0].fecha_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Lista de convenios del contrato',
    visible: true,
  },
  // Estimaciones
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'estimaciones',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">
        {FOR estimacion IN estimaciones}<br>{INS $estimacion.numero} - {INS $estimacion.fechaDel} - {INS $estimacion.fechaAl} - {INS $estimacion.totalFactura}
        <br>{END-FOR estimacion}</span> = <br>1 - 01/02/2022 - 28/02/2022 - 803,880.00<br>2 - 01/03/2022 - 30/03/2022 - 950,000.00
        <br><br>Primera Estimación:
        <br><span style="color:blue;font-weight:bold;">
        {estimaciones[0].numero}</span> = 1
        <br><span style="color:blue;font-weight:bold;">
        {estimaciones[0].fechaDel}</span> = 01/02/2022
        <br><span style="color:blue;font-weight:bold;">
        {estimaciones[0].fechaAl}</span> = 28/02/2022
        <br><span style="color:blue;font-weight:bold;">
        {estimaciones[0].porcentajeIva}</span> = 16
        <br><span style="color:blue;font-weight:bold;">
        {estimaciones[0].importeEstimado}</span> = 1,000,000.00
        <br><span style="color:blue;font-weight:bold;">
        {estimaciones[0].importeRetenido}</span> = 0.00
        <br><span style="color:blue;font-weight:bold;">
        {estimaciones[0].importeDevuelto}</span> = 0.00
        <br><span style="color:blue;font-weight:bold;">
        {estimaciones[0].importeNeto}</span> = 1,000,000.00
        <br><span style="color:blue;font-weight:bold;">
        {estimaciones[0].importeAmortizacionAnticipo}</span> = 300,000.00
        <br><span style="color:blue;font-weight:bold;">
        {estimaciones[0].importeDeducciones}</span> = 7,000.00
        <br><span style="color:blue;font-weight:bold;">
        {estimaciones[0].subtotal}</span> = 693,000.00
        <br><span style="color:blue;font-weight:bold;">
        {estimaciones[0].importeIva}</span> = 110,880.00
        <br><span style="color:blue;font-weight:bold;">
        {estimaciones[0].totalFactura}</span> = 803,880.00
        <br><span style="color:blue;font-weight:bold;">
        {estimaciones[0].importeBonificacion}</span> = 0.00
        <br><span style="color:blue;font-weight:bold;">
        {estimaciones[0].importeSancion}</span> = 0.00
        <br><span style="color:blue;font-weight:bold;">
        {estimaciones[0].importeLiquido}</span> = 803,880.00
        <br><span style="color:blue;font-weight:bold;">
        {estimaciones[0].bonificacionDetalle}</span> = 0.00
        <br><span style="color:blue;font-weight:bold;">
        {estimaciones[0].esEstimacionFinPrograma}</span> = NO
        <br><span style="color:blue;font-weight:bold;">
        {estimaciones[0].esEstimacionFiniquito}</span> = NO
        <br><br>Para totalFactura en texto utilice
        <br><span style="color:blue;font-weight:bold;">
        {estimaciones[0].totalFactura_texto}</span> = OCHOCIENTOS TRES MIL OCHOCIENTOS OCHENTA PESOS 00/100 CENTAVOS M.N.,
        <br><br>Para el resto de importes agregue _texto al nombre<br>del dato para obtener el importe en texto.
        <br><br>Para fechaDel en texto utilice
        <br><span style="color:blue;font-weight:bold;">
        {estimaciones[0].fechaDel_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Lista de estimaciones del contrato',
    visible: true,
  },
  // Fianza ANTICIPO
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'fianza_anticipo.numero',
    salida: '<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{fianza_anticipo.numero} </span> = "1388-01416-0..."',
    descripcion: 'Número de la fianza por anticipo',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'fianza_anticipo.fecha',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">{fianza_anticipo.fecha}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{fianza_anticipo.fecha_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{fianza_anticipo.fecha_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Fecha de la fianza por anticipo',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'fianza_anticipo.monto',
    salida: `<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{fianza_anticipo.monto}</span> = 100,000.00
              <br><span style="color:blue;font-weight:bold;">{fianza_anticipo.monto_texto} </span> = CIEN MIL PESOS 00/100 CENTAVOS M.N.`,
    descripcion: 'Monto de la fianza por anticipo',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'fianza_anticipo.nombreAfianzadora',
    salida: '<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{fianza_anticipo.nombreAfianzadora} </span> = "ASEGURADORA ASERTA..."',
    descripcion: 'Nombre de la afianzadora que expide fianza por anticipo',
    visible: true,
  },
  // Fianza CUMPLIMIENTO
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'fianza_cumplimiento.numero',
    salida: '<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{fianza_cumplimiento.numero} </span> = "1388-01416-0..."',
    descripcion: 'Número de la fianza por cumplimiento',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'fianza_cumplimiento.fecha',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">{fianza_cumplimiento.fecha}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{fianza_cumplimiento.fecha_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{fianza_cumplimiento.fecha_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Fecha de la fianza por cumplimiento',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'fianza_cumplimiento.monto',
    salida: `<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{fianza_cumplimiento.monto}</span> = 100,000.00
              <br><span style="color:blue;font-weight:bold;">{fianza_cumplimiento.monto_texto} </span> = CIEN MIL PESOS 00/100 CENTAVOS M.N.`,
    descripcion: 'Monto de la fianza por cumplimiento',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'fianza_cumplimiento.nombreAfianzadora',
    salida: '<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{fianza_cumplimiento.nombreAfianzadora} </span> = "ASEGURADORA ASERTA..."',
    descripcion: 'Nombre de la afianzadora que expide fianza por cumplimiento',
    visible: true,
  },
  // Fianza VICIOS OCULTOS
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'fianza_viciosocultos.numero',
    salida: '<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{fianza_viciosocultos.numero} </span> = "1388-01416-0..."',
    descripcion: 'Número de la fianza por vicios ocultos',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'fianza_viciosocultos.fecha',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">{fianza_viciosocultos.fecha}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{fianza_viciosocultos.fecha_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{fianza_viciosocultos.fecha_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Fecha de la fianza por vicios ocultos',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'fianza_viciosocultos.monto',
    salida: `<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{fianza_viciosocultos.monto}</span> = 100,000.00
              <br><span style="color:blue;font-weight:bold;">{fianza_viciosocultos.monto_texto} </span> = CIEN MIL PESOS 00/100 CENTAVOS M.N.`,
    descripcion: 'Monto de la fianza por vicios ocultos',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'fianza_viciosocultos.nombreAfianzadora',
    salida: '<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{fianza_viciosocultos.nombreAfianzadora} </span> = "ASEGURADORA ASERTA..."',
    descripcion: 'Nombre de la afianzadora que expide fianza por vicios ocultos',
    visible: true,
  },
  // FECHAS IMPORTANTES
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'fechaReinicioTrabajos',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">
        {FOR reinicio IN fechaReinicioTrabajos}<br>{INS $reinicio.fecha} - {INS $reinicio.fecha_texto}
        <br>{END-FOR reinicio}</span> = <br>01/02/2022 - 01 de febrero de 2022
        `,
    descripcion: 'Lista de fechas de reinicio de trabajos',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'fechaSuspensionTrabajos',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">
        {FOR suspension IN fechaSuspensionTrabajos}<br>{INS $suspension.fecha} - {INS $suspension.fecha_texto}
        <br>{END-FOR suspension}</span> = <br>01/02/2022 - 01 de febrero de 2022
        `,
    descripcion: 'Lista de fechas de suspensión de trabajos',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_fechaEntregaProyecto',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">{contrato_fechaEntregaProyecto}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaEntregaProyecto_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaEntregaProyecto_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Fecha de entrega del Proyecto',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_fechaEntregaSitio',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">{contrato_fechaEntregaSitio}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaEntregaSitio_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaEntregaSitio_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Fecha de entrega de Sitio',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_fechaAvisoTerminacion',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">{contrato_fechaAvisoTerminacion}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaAvisoTerminacion_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaAvisoTerminacion_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Fecha de aviso de Terminación',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_fechaVerificacionTrabajos',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">{contrato_fechaVerificacionTrabajos}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaVerificacionTrabajos_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaVerificacionTrabajos_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Fecha de verificación de los trabajos',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_fechaRecepcionTrabajos',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">{contrato_fechaRecepcionTrabajos}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaRecepcionTrabajos_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaRecepcionTrabajos_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Fecha de recepción de los trabajos',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_fechaCierreBitacora',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">{contrato_fechaCierreBitacora}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaCierreBitacora_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaCierreBitacora_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Fecha de cierre de bitácora',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_fechaActaFiniquito',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">{contrato_fechaActaFiniquito}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaActaFiniquito_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaActaFiniquito_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Fecha de acta finiquito',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_fechaActaExtincion',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">{contrato_fechaActaExtincion}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaActaExtincion_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaActaExtincion_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Fecha de acta de extinción',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_fechaEntregaObra',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">{contrato_fechaEntregaObra}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaEntregaObra_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaEntregaObra_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Fecha de entrega de obra',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_fechaSolicitudTerminacionAnticipada',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">{contrato_fechaSolicitudTerminacionAnticipada}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaSolicitudTerminacionAnticipada_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaSolicitudTerminacionAnticipada_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Fecha de solicitud de terminación anticipada',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_fechaTerminacionAnticipada',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">{contrato_fechaTerminacionAnticipada}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaTerminacionAnticipada_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaTerminacionAnticipada_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Fecha de terminación anticipada',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_fechaInicioRescisionAdministrativa',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">{contrato_fechaInicioRescisionAdministrativa}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaInicioRescisionAdministrativa_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaInicioRescisionAdministrativa_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Fecha de inicio de rescisión administrativa',
    visible: true,
  },
  {
    modulo: 'contratos, ejecucion',
    etiqueta: 'contrato_fechaRescisionAdministrativa',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">{contrato_fechaRescisionAdministrativa}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaRescisionAdministrativa_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{contrato_fechaRescisionAdministrativa_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Fecha de rescisión administrativa',
    visible: true,
  },
  // MODULO LICITACIONES
  {
    modulo: 'licitaciones',
    etiqueta: 'licitacion_tipo',
    salida: '<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{licitacion_tipo}</span> = LICITACIÓN PÚBLICA',
    descripcion: 'Tipo de licitación',
    visible: true,
  },
  {
    modulo: 'licitaciones',
    etiqueta: 'licitacion_numero',
    salida: '<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{licitacion_numero}</span> = LP-CIDUE-MD-OP-04-2022',
    descripcion: 'Número de licitación',
    visible: true,
  },
  {
    modulo: 'licitaciones',
    etiqueta: 'licitacion_caracter',
    salida: '<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{licitacion_caracter}</span> = NACIONAL',
    descripcion: 'Caracter de licitación',
    visible: true,
  },
  {
    modulo: 'licitaciones',
    etiqueta: 'licitacion_normatividad',
    salida: '<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{licitacion_normatividad}</span> = FEDERAL',
    descripcion: 'Normatividad aplicable a la licitación',
    visible: true,
  },
  {
    modulo: 'licitaciones',
    etiqueta: 'licitacion_objeto',
    salida: '<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{licitacion_objeto}</span> = Construcción de vialidades a base de concreto hidraúlico en la avenida Opodepe...',
    descripcion: 'Redacción del objeto completo de la licitación',
    visible: true,
  },
  {
    modulo: 'licitaciones',
    etiqueta: 'licitacion_numeroConvocatoria',
    salida: '<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{licitacion_numeroConvocatoria}</span> = E4',
    descripcion: 'Número de Convocatoria',
    visible: true,
  },
  {
    modulo: 'licitaciones',
    etiqueta: 'licitacion_fechaConvocatoria',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">{licitacion_fechaConvocatoria}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{licitacion_fechaConvocatoria_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{licitacion_fechaConvocatoria_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Fecha de inicio de la licitación',
    visible: true,
  },
  {
    modulo: 'licitaciones',
    etiqueta: 'licitacion_fechaInicio',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">{licitacion_fechaInicio}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{licitacion_fechaInicio_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{licitacion_fechaInicio_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Fecha de inicio de la licitación',
    visible: true,
  },
  {
    modulo: 'licitaciones',
    etiqueta: 'licitacion_fechaTermino',
    salida: `<br>Ejemplo de uso: <br><span style="color:blue;font-weight:bold;">{licitacion_fechaTermino}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{licitacion_fechaTermino_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{licitacion_fechaTermino_texto}</span> = 01 de febrero de 2022`,
    descripcion: 'Fecha de termino de la licitación',
    visible: true,
  },
  {
    modulo: 'licitaciones',
    etiqueta: 'licitacion_plazo',
    salida: '<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{licitacion_plazo}</span> = 20',
    descripcion: 'Número de días de plazo ',
    visible: true,
  },
  {
    modulo: 'licitaciones',
    etiqueta: 'licitacion_anticipoMaterial',
    salida: '<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{licitacion_anticipoMaterial}</span> = 20.0',
    descripcion: 'Porcentaje de anticipo en materiales',
    visible: true,
  },
  {
    modulo: 'licitaciones',
    etiqueta: 'licitacion_anticipoInicio',
    salida: '<br>Ejemplo de uso:<br><span style="color:blue;font-weight:bold;">{licitacion_anticipoInicio}</span> = 10.0',
    descripcion: 'Porcentaje de anticipo inicial',
    visible: true,
  },
  // Evento visitaObra
  {
    modulo: 'licitaciones',
    etiqueta: 'visitaObra',
    salida: `<br>Ejemplo de uso: <br>
                <br><span style="color:blue;font-weight:bold;">{visitaObra.fecha}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{visitaObra.fecha_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{visitaObra.fecha_texto}</span> = 01 de febrero de 2022
                <br><span style="color:blue;font-weight:bold;">{visitaObra.hora}</span> = 09:00
                <br><span style="color:blue;font-weight:bold;">{visitaObra.lugar}</span> = Sala...
              <br><br>Participantes
              <br><span style="color:blue;font-weight:bold;">
              {FOR participante IN visitaObra.participantes}
                <br>{INS $participante.rfc} - {INS $participante.asistio} - 
                {INS $participante.nombreRazonSocial} - {INS $participante.nombreRepresentante} 
                - {INS $participante.correoElectronico}
              <br>{END-FOR participante}</span> 
                = <br>CASA800329... - SI - CONSTRUCCIONES SA... - JUAN GOMEZ... - co@correo.com`,
    descripcion: 'Datos generales y participantes de la Visita de la Obra ',
    visible: true,
  },
  // Evento juntaAclaraciones
  {
    modulo: 'licitaciones',
    etiqueta: 'juntaAclaraciones',
    salida: `<br>Ejemplo de uso: <br>
                <br><span style="color:blue;font-weight:bold;">{juntaAclaraciones.fecha}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{juntaAclaraciones.fecha_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{juntaAclaraciones.fecha_texto}</span> = 01 de febrero de 2022
                <br><span style="color:blue;font-weight:bold;">{juntaAclaraciones.hora}</span> = 09:00
                <br><span style="color:blue;font-weight:bold;">{juntaAclaraciones.lugar}</span> = Sala...
              <br><br>Participantes
              <br><span style="color:blue;font-weight:bold;">
              {FOR participante IN juntaAclaraciones.participantes}
                <br>{INS $participante.rfc} - {INS $participante.asistio} - 
                {INS $participante.nombreRazonSocial} - {INS $participante.nombreRepresentante} 
                - {INS $participante.correoElectronico}
              <br>{END-FOR participante}</span> 
                = <br>CASA800329... - SI - CONSTRUCCIONES SA... - JUAN GOMEZ... - co@correo.com`,
    descripcion: 'Datos generales y participantes de la Junta de Aclaraciones ',
    visible: true,
  },
  // Evento fallo
  {
    modulo: 'licitaciones',
    etiqueta: 'fallo',
    salida: `<br>Ejemplo de uso: <br>
                <br><span style="color:blue;font-weight:bold;">{fallo.fecha}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{fallo.fecha_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{fallo.fecha_texto}</span> = 01 de febrero de 2022
                <br><span style="color:blue;font-weight:bold;">{fallo.hora}</span> = 09:00
                <br><span style="color:blue;font-weight:bold;">{fallo.lugar}</span> = Sala...
              <br><br>Participantes
              <br><span style="color:blue;font-weight:bold;">
              {FOR participante IN fallo.participantes}
                <br>{INS $participante.rfc} - {INS $participante.asistio} - 
                {INS $participante.nombreRazonSocial} - {INS $participante.nombreRepresentante} 
                - {INS $participante.correoElectronico}
              <br>{END-FOR participante}</span> 
                = <br>CASA800329... - SI - CONSTRUCCIONES SA... - JUAN GOMEZ... - co@correo.com`,
    descripcion: 'Datos generales y participantes del Fallo ',
    visible: true,
  },
  // Evento aperturaPropuestas
  {
    modulo: 'licitaciones',
    etiqueta: 'aperturaPropuestas',
    salida: `<br>Ejemplo de uso: <br>
                <br><span style="color:blue;font-weight:bold;">{aperturaPropuestas.fecha}</span> = 01/02/2022
                <br><span style="color:blue;font-weight:bold;">{aperturaPropuestas.fecha_guion}</span> = 01-Febrero-2022
                <br><span style="color:blue;font-weight:bold;">{aperturaPropuestas.fecha_texto}</span> = 01 de febrero de 2022
                <br><span style="color:blue;font-weight:bold;">{aperturaPropuestas.hora}</span> = 09:00
                <br><span style="color:blue;font-weight:bold;">{aperturaPropuestas.lugar}</span> = Sala...
              <br><br>Participantes
              <br><span style="color:blue;font-weight:bold;">
              {FOR participante IN aperturaPropuestas.participantes}
                <br>{INS $participante.rfc} - {INS $participante.asistio} - 
                {INS $participante.nombreRazonSocial} - {INS $participante.nombreRepresentante} 
                - {INS $participante.correoElectronico}<br>
                {INS $participante.aceptadaRevision} - {INS $participante.completa} - {INS $participante.pasoRevision}<br>
                {INS $participante.importe} - {INS $participante.porcentajeIva} - 
                {INS $participante.importeIva} - {INS $participante.total}<br>
                {INS $participante.observaciones}
              <br>{END-FOR participante}</span> 
                = <br>CASA800329... - SI - CONSTRUCCIONES SA... - JUAN GOMEZ... - co@correo.com`,
    descripcion: 'Datos generales y participantes de la Apertura de Propuestas ',
    visible: true,
  },
];
